const csvProcessor = {
  noProjectMessage: "Vinsamlegast veldu verkefni áður en CSV-gögn eru unnin.",
  heading: "Úrvinnsla CSV-gagna",
  projectLabel: "Verkefni:",
  dropzone: {
    clickOrDrag: "Smelltu til að velja eða dragðu CSV-skrá hingað",
    hint: "Aðeins CSV-skrár, að hámarki 50 MB",
  },
  fileInfo: {
    summary: "{{columns}} dálkar, {{rows}} raðir",
    changeFileButton: "Skipta um skrá",
  },
  columnSelection: {
    heading: "Veldu dálka til að dulnefna",
    selectAllButton: "Velja alla",
    clearButton: "Hreinsa",
    selectedSummary: "Valið: {{selected}} af {{total}} dálkum",
  },
  actions: {
    processing: "Vinn úr gögnum...",
    deidentifyButton: "Dulnefna {{count}} dálka",
    reverseButton: "Afturkalla (stjórnandi)",
  },
  results: {
    heading: "Úrvinnsluniðurstaða",
    downloadButton: "Sækja CSV",
    rowsCaption_one: "{{count}} röð",
    rowsCaption_other: "{{count}} raðir",
    showingFirstCaption: "Sýnir fyrstu {{shown}} af {{total}} röðum",
  },
  messages: {
    processedWithWarningsSuffix: "(Unnið úr með ábendingum um dálka)",
  },
  errors: {
    csvOnly: "Vinsamlegast hlaðið upp eingöngu CSV-skrá",
    fileTooLarge: "Skráin má ekki vera stærri en 50 MB",
    selectFileAndColumns:
      "Vinsamlegast hlaðið upp CSV-skrá og veljið dálka til að dulnefna",
    validationOrProcessingFailed: "Staðfesting eða dulnefning mistókst",
    processingFailed: "Dulnefning mistókst",
    reverseNotAllowed: "Afturköllun er aðeins í boði fyrir stjórnendur",
    selectFileAndColumnsReverse:
      "Vinsamlegast hlaðið upp CSV-skrá og veljið dálka til að afturkalla",
    reverseFailed: "Afturköllun mistókst",
  },
};

export default csvProcessor;
